import { createContext, useEffect, useState } from "react";
import { MdErrorOutline } from "react-icons/md";
import { apiFetch } from "../components/services/fetchApi";
import { fetchNotification, notificationCount, readAllNotification, readNotification } from "../components/services/fetchNotification";

export const DContext = createContext()

const DataContext = ({ children }) => {

    const BeURL = process.env.REACT_APP_BeURL
    const [isAuth, setIsAuth] = useState(null)
    const [currentUser, setCurrentUser] = useState(null)
    // const [options, setOptions] = useState({})
    const [getNotification, setGetNotification] = useState([]);
    const [count, setCount] = useState(0)

    const [popup, setPopup] = useState({
        visible: false,
        message: '',
        type: 'alert',  // 'alert' | 'confirm'
        resolve: () => { },
    });

    const showAlert = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'alert',
                resolve,
            });
        });

    const showConfirm = (message, fileName) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'confirm',
                fileName,
                resolve,
            });
        });

    const showDeleteConfirm = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: "delete",
                resolve,
            });
        });


    const handlePopupConfirm = () => {
        popup.resolve(true);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    const handlePopupCancel = () => {
        popup.resolve(false);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    // useEffect(() => {
    //     apiFetch(`${BeURL}/fetch-users-options`, {
    //         method: 'GET'
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setOptions(data)
    //         })
    //         .catch(err => {
    //             console.log("Error in fetch users Options", err)
    //         })
    // }, [BeURL])

    const handleNotification = (perPage, currentPage, setTotalPages, setTotalCount) => {
        fetchNotification(setGetNotification, BeURL, showAlert, perPage, currentPage, setTotalPages, setTotalCount);
    };

    const notificationReadAction = (id) => {
        readNotification(id, BeURL)
    }

    const notificationReadActionAll = (id) => {
        readAllNotification(id, BeURL)
    }

    useEffect(() => {
        const fetchCount = async () => {
            const result = await notificationCount(BeURL, showAlert);

            if (result.success) {
                setCount(result.count);
            }
        };
        fetchCount();
    }, [BeURL]);


    const checkAuth = async () => {
        try {
            const res = await apiFetch(`${BeURL}/checkauth`, {
                method: "GET",
            });

            const data = await res.json();

            if (data.success) {
                setIsAuth(true);
                setCurrentUser(data.user);
            } else {
                setIsAuth(false);
                setCurrentUser({});
            }
        } catch (err) {
            setIsAuth(null);
            setCurrentUser(null);
            console.log("Error in fetching User:", err);
            // alert("Trouble in connecting to the Server, please try again later.");
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const handleLogout = async () => {
        if (!localStorage.getItem("accessToken")) {
            window.location.href = '/'
            return
        }
        try {
            const res = await apiFetch(`${BeURL}/logout`, {
                method: "GET",
            });
            const data = await res.json()

            if (data.success) {

                localStorage.removeItem('accessToken')


                setIsAuth(false)
                setCurrentUser(null)
                window.location.href = '/'
            }
            else {
                showAlert(data.message)
                window.location.reload()
            }
        }
        catch (err) {
            console.log("Error in Logout:", err)
            alert("Trouble in connecting to the Server, please try again later.")
        }
    }

    const renderError = (msg) => {
        if (msg) {
            return <div className='my-2 text-red-500 px-2 py-1 bg-red-50 rounded-lg flex gap-2 items-center'><MdErrorOutline className='flex-shrink-0' /><p className='text-sm'>{msg}</p></div>
        }
        else return null
    }



    function isValidAlphabeticString(value) {
        if (typeof value !== 'string') return false;

        const cleaned = value.toLowerCase().trim();

        const hasNumber = /\d/.test(cleaned);
        const isAlphabetOnly = /^[a-z\s]+$/.test(cleaned); // allows only letters and spaces

        return (!hasNumber && isAlphabetOnly) || false;
    }

    // const manBadge = () => {
    //     return <span className='text-red-600 text-lg font-medium'> *</span>
    // }

    const formatPeriod = (isoDateStr) => {
        if (!isoDateStr) return { year: "", month: "", date: "" };

        const date = new Date(isoDateStr);
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Month short names
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // If default 01-01 → skip month/day
        if (month === "01" && day === "01") {
            return { year, month: "", date: "" };
        } else {
            return { year, month: monthNames[date.getMonth()], date: day };
        }
    };
    // options
    const data = {
        isAuth, currentUser, setIsAuth, setCurrentUser, BeURL, handleLogout, renderError, popup, showDeleteConfirm,
        showAlert, showConfirm, handlePopupConfirm, handlePopupCancel, isValidAlphabeticString, formatPeriod,
        handleNotification, getNotification, notificationReadAction, notificationReadActionAll, count
    }

    return (
        <DContext.Provider value={data}>
            {children}
        </DContext.Provider>
    )
}

export default DataContext